import cn from 'clsx'

import { getSanityLink } from 'shared-functions'

import { Button, Copy } from 'shared-components'

import Project from './Project'

import s from './ProjectList.module.sass'

function ProjectList({ title, copy, link, projects }: any) {
    const _link = link?.linkType === 'internal' || link?.linkType === 'external' ? getSanityLink(link) || null : null

    return (
        <section className={s.ProjectList}>
            {(title || copy || _link) && (
                <div className={s.Intro}>
                    <div className={cn(s.Cont, 'container')}>
                        {title && <h2 dangerouslySetInnerHTML={{ __html: title }} />}
                        {copy && (
                            <div className={s.Copy}>
                                <Copy copy={copy} size="small" />
                            </div>
                        )}
                        {_link && <Button url={_link?.url || ''} title={_link?.title || ''} />}
                    </div>
                </div>
            )}
            {projects?.map((project: any, index: number) => <Project project={project} key={index} />)}
        </section>
    )
}

export default ProjectList
